import styled from 'styled-components';

export const NavigationWrapper = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  padding: 2.4rem 3.2rem;
  width: 22rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid #f3f4f6;
  background: #fff;

  @media only screen and (max-width: 1456px) {
    padding-left: 1.6rem;
  }

  @media only screen and (max-width: 768px) {
    display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
    position: fixed;
    width: unset;
    top: unset;
    right: 0;
    left: 0;
    border: none;
    height: 5.6rem;
    z-index: 10;
    padding: unset;
    border-right: unset;
  }
`;

export const NavigationContainer = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    flex-direction: row;
    height: 100%;
    padding: 0 6.4rem;
    align-items: center;
    border-top: 1px solid #f3f3fb;
    background: #f9fafb;
  }
`;

export const Badge = styled.div`
  border-radius: 0px 100px 100px 0px;
  background: linear-gradient(270deg, #62a4e7 0%, #2550bb 175%);
  width: 2px;
  height: 12px;
  position: absolute;
  left: 0;
  display: none;
`;

export const RedDot = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  left: 1.5rem;
  top: 0.9rem;
`;

export const NavigationItem = styled.div`
  font-size: 1.4rem;
  font-weight: 300;
  line-height: normal;
  a {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #0b3a5f;
    text-decoration: none;
    padding: 0.8rem 1.2rem;
    border: 1px solid transparent;
    position: relative;

    svg {
      color: #0b3a5f;
    }
  }

  a.active {
    color: #040b10;
    font-weight: 400;
    border-radius: 12px;
    border: 1px solid #eef2f6;
    background: #fff;
    box-shadow: 4px 5px 2px 0px rgba(0, 0, 0, 0), 2px 3px 2px 0px rgba(0, 0, 0, 0.01);

    ${Badge} {
      @media only screen and (min-width: 768px) {
        display: block;
      }
    }

    svg {
      color: #040b10;
    }
  }
`;

export const NavigationItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  @media only screen and (max-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const NavigationFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavLinkText = styled.span`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavLinkIconWrapper = styled.div`
  height: 2.7rem;
`;

export const LogoWrapper = styled.div`
  margin-bottom: 2.4rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const FooterButton = styled.button`
  border-radius: 16px;
  background: #fff;
  width: 15.6rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  font-size: 1.4rem;
  cursor: pointer;
  font-weight: 300;
  padding: 0.6rem 0.6rem 0.6rem 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 2rem 0 2rem 1rem;
`;

export const Avatar = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
`;

export const PostStoryBtn = styled.button`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  color: white;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: -0.42px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.8rem 0;
`;
